import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';

import Page from '../../page.jsx';
import partnerPropTypes from '../../partnerPropTypes';
import { data as paymentDataPropTypes } from '../../paymentPropTypes.js';
import { formatDate } from '../../getDeadline.js';

const HandleItemPage = ({ payment, partner }) => (
    <Page heading="Har du fått varen?">
        <div>
            <p>
                Husk å gi beskjed innen{' '}
                <span className="strong">
                    {formatDate(payment.automaticApprove)}
                </span>.
            </p>

            <p>Da overføres pengene automatisk til {partner.name}.</p>

            <div className="r-pal">
                <Link to="/godkjenn-utbetaling" className="button fullwidth">
                    Ja, og alt er OK
                </Link>
            </div>

            <div className="r-phl">
                <Link
                    to="/losning/noe-er-galt-med-varen"
                    className="button fullwidth"
                >
                    Ja, men noe er galt
                </Link>
            </div>

            <div className="r-pal">
                <Link to="/losning/manglende-vare" className="button fullwidth">
                    Nei, jeg har ikke fått varen
                </Link>
            </div>
        </div>
    </Page>
);

HandleItemPage.propTypes = {
    itemId: PropTypes.string.isRequired,
    payment: paymentDataPropTypes.isRequired,
    partner: partnerPropTypes.isRequired,
};

function mapStateToProps(state) {
    return {
        itemId: state.safeTrade.itemId,
        payment: state.payment.data,
        partner: state.partner,
    };
}

export default connect(mapStateToProps)(HandleItemPage);



// WEBPACK FOOTER //
// ./safeTrade/buyer/agreement/handleItemPage.jsx